(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageRelationshipDeleteController',PublicSiteLanguageRelationshipDeleteController);

    PublicSiteLanguageRelationshipDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteLanguageRelationship'];

    function PublicSiteLanguageRelationshipDeleteController($uibModalInstance, entity, PublicSiteLanguageRelationship) {
        var vm = this;

        vm.publicSiteLanguageRelationship = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteLanguageRelationship.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
